import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";
import { forkJoin } from "rxjs";
import { Configuracoes } from "../entities/configuracoes";
import { ToastrService } from "ngx-toastr";
import { HttpService } from "./http-service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
@Injectable({
  providedIn: "root",
})
export class DownloadImagesService extends HttpService {
  getRequests = [];
  data = [];
  loading: Boolean = false;
  toastLoadingId: number;

  constructor(
    private _http: HttpClient,
    router: Router,
    public toastService: ToastrService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public http: HttpClient
  ) {
    super(http, router, toastService, platformId);
  }

  clear() {
    this.data = [];
  }

  append(data) {
    this.data = this.data.concat(data);
  }

  async download(fileName: string) {
    this.showLoading();
    const zip = new JSZip();

    for (let index = 0; index < this.data.length; index++) {
      const url = this.data[index];
      try {
        let blob = await this._http
          .get(url, { responseType: "blob" })
          .toPromise();
        const name = url.replace(Configuracoes.API_IMAGENS, "");
        zip.file(`${name}`, blob);
      } catch (e) {
        console.log(e);
      }
    }

    zip.generateAsync({ type: "blob" }).then((blob) => {
      saveAs(blob, `${fileName}.zip`);
    });

    this.data = [];
    this.dimissLoading();
  }

  getFotosPedido(id, callback) {
    this.get(`produto/fotosPedido/${id}`, callback);
  }

  getPdf(body): Observable<Blob> {
    return this._http.post("http://localhost:3001/pdf", body, {
      responseType: "blob",
    });
  }

  showLoading() {
    this.loading = true;
    this.toastLoadingId = this.toastService.show(
      '<div class="spinner-grow text-primary" role="status"><span class="sr-only">Loading...</span></div>',
      "",
      {
        enableHtml: true,
      }
    ).toastId;
  }

  dimissLoading() {
    this.loading = false;
    this.toastService.clear(this.toastLoadingId);
  }
}
